import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

import { Loader } from '~shared/ui/loader';

import { isAuthorisedAtom } from '@breezeventures/web-ph-client-auth/model';
import { useAtomValue } from 'jotai';

import { useGetPermissions } from '../entities/permissions';
import { getDefaultRouteByPermissions } from '../lib';

export const AnonymousGuard = ({ children }: PropsWithChildren) => {
  const isAuthorised = useAtomValue(isAuthorisedAtom);
  const permissionsQuery = useGetPermissions({
    enabled: isAuthorised,
  });

  if (!isAuthorised) {
    return children;
  }

  if (permissionsQuery.data) {
    return (
      <Navigate
        to={getDefaultRouteByPermissions(permissionsQuery.data)}
        replace
      />
    );
  }

  return <Loader />;
};
